module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', [_c('clipPath', {
    attrs: {
      "id": "a"
    }
  }, [_c('path', {
    attrs: {
      "d": "m0 0h97.28v215.13h-97.28z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "b"
    }
  }, [_c('path', {
    attrs: {
      "d": "m20.49 63.09h11.87v7.45h-11.87z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "c"
    }
  }, [_c('path', {
    attrs: {
      "d": "m65.49 63.09h11.87v7.45h-11.87z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "d"
    }
  }, [_c('path', {
    attrs: {
      "d": "m31.83 168.66h12.69v34.59h-12.69z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "e"
    }
  }, [_c('path', {
    attrs: {
      "d": "m30.45 206.06h8.82v6.16h-8.82z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "f"
    }
  }, [_c('path', {
    attrs: {
      "d": "m53.42 168.66h12.69v34.59h-12.69z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "g"
    }
  }, [_c('path', {
    attrs: {
      "d": "m58.71 206.06h8.82v6.16h-8.82z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "h"
    }
  }, [_c('path', {
    attrs: {
      "d": "m3.71 48.96h6.51v21.76h-6.51z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "i"
    }
  }, [_c('path', {
    attrs: {
      "d": "m2.73 75.5h6.51v21.77h-6.51z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "j"
    }
  }, [_c('path', {
    attrs: {
      "d": "m38.52 3.48h34.26v22.42h-34.26z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "k"
    }
  }, [_c('path', {
    attrs: {
      "d": "m13.93 4.19h24.35v20.99h-24.35z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "l"
    }
  }, [_c('path', {
    attrs: {
      "d": "m68.51 25.44h23.36v20.56h-23.36z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "m"
    }
  }, [_c('path', {
    attrs: {
      "d": "m4.99 21.85h21.27v23.22h-21.27z"
    }
  })]), _c('g', {
    attrs: {
      "clip-path": "url(#a)"
    }
  }, [_c('path', {
    attrs: {
      "d": "m87.85 48.07-1.97 57.75 11.4 4.8-3.28-67.56z",
      "fill": "#b67753"
    }
  }), _c('g', {
    attrs: {
      "clip-path": "url(#a)"
    }
  }, [_c('path', {
    attrs: {
      "d": "m12 102s33.92-23.37 73.91 3.85l3.74-48.94h-81.97z",
      "fill": "#7b4a36"
    }
  }), _c('path', {
    attrs: {
      "d": "m90.29 52.58c0 20.21-18.52 36.59-41.37 36.59s-41.37-16.39-41.37-36.59 18.52-36.58 41.37-36.58 41.37 16.36 41.37 36.58",
      "fill": "#fab18c"
    }
  }), _c('path', {
    attrs: {
      "d": "m2.35 59.91c.2 3.31 2.52 5.86 5.17 5.7s4.64-3 4.43-6.29-2.52-5.86-5.17-5.7-4.63 3-4.43 6.29",
      "fill": "#fab18c"
    }
  }), _c('path', {
    attrs: {
      "d": "m4.71 55.48a2.49 2.49 0 0 1 1.17-.29c1.75 0 3 3 1.25 3.39a1.14 1.14 0 0 0 0 1.5c.56.73 1.32 1.79 1.09 2.78a1.57 1.57 0 0 1 -1.32 1c-.44.09-.51-.28-.16-.44a2 2 0 0 0 .69-.56l.06-.1v-.07a.68.68 0 0 0 0-.44 1 1 0 0 1 -1.35-.09c-.31-.45 0-1.11-.12-1.61a3.86 3.86 0 0 0 -.36-1c-.73-1.49.73-1.66.73-1.66a4.24 4.24 0 0 1 .61.11c.75-.38 0-1.6-.45-1.82a1.31 1.31 0 0 0 -1.55.18 2.51 2.51 0 0 0 -.58 1.64 6 6 0 0 0 .38 2c.14.36.32.79.47 1.16s-.29.57-.45.15a12.79 12.79 0 0 1 -1.08-3.31 2.61 2.61 0 0 1 1-2.52",
      "fill": "#e69780"
    }
  }), _c('path', {
    attrs: {
      "d": "m95.49 59.91c-.21 3.31-2.52 5.86-5.17 5.7s-4.63-3-4.43-6.29 2.52-5.86 5.17-5.7 4.63 3 4.43 6.29",
      "fill": "#fab18c"
    }
  }), _c('path', {
    attrs: {
      "d": "m93.13 55.48a2.49 2.49 0 0 0 -1.13-.29c-1.76 0-3 3-1.25 3.39a1.15 1.15 0 0 1 0 1.5c-.57.73-1.32 1.79-1.1 2.78a1.57 1.57 0 0 0 1.31 1c.45.09.51-.28.16-.44a2 2 0 0 1 -.69-.56l-.06-.1v-.07a.71.71 0 0 1 0-.44 1 1 0 0 0 1.35-.09c.31-.45 0-1.11.12-1.61a3.86 3.86 0 0 1 .36-1c.73-1.49-.73-1.66-.73-1.66a4.16 4.16 0 0 0 -.53.07c-.75-.38 0-1.6.44-1.82a1.32 1.32 0 0 1 1.54.21 2.52 2.52 0 0 1 .5 1.65 6 6 0 0 1 -.42 2c-.14.36-.32.79-.47 1.16s.28.57.45.15a12.54 12.54 0 0 0 1.12-3.31 2.61 2.61 0 0 0 -1-2.52",
      "fill": "#e69780"
    }
  }), _c('path', {
    attrs: {
      "d": "m51.9 65.69a.69.69 0 0 1 -.7-.69 2.28 2.28 0 1 0 -4.56 0 .69.69 0 1 1 -1.38 0 3.66 3.66 0 1 1 7.33 0 .69.69 0 0 1 -.69.69",
      "fill": "#e9967d"
    }
  }), _c('g', {
    attrs: {
      "clip-path": "url(#b)",
      "opacity": ".3"
    }
  }, [_c('path', {
    attrs: {
      "d": "m20.49 66.82c0 2.06 2.65 3.73 5.93 3.73s5.93-1.67 5.93-3.73-2.66-3.73-5.93-3.73-5.93 1.67-5.93 3.73",
      "fill": "#f77887"
    }
  })]), _c('g', {
    attrs: {
      "clip-path": "url(#c)",
      "opacity": ".3"
    }
  }, [_c('path', {
    attrs: {
      "d": "m65.49 66.82c0 2.06 2.65 3.73 5.93 3.73s5.93-1.67 5.93-3.73-2.66-3.73-5.93-3.73-5.93 1.67-5.93 3.73",
      "fill": "#f77887"
    }
  })]), _c('path', {
    attrs: {
      "d": "m48.92 77a12.23 12.23 0 0 1 -6.54-2.84.54.54 0 0 1 -.13-.66.36.36 0 0 1 .55-.16 18.25 18.25 0 0 0 12.25 0 .39.39 0 0 1 .55.16.54.54 0 0 1 -.13.66c-2.18 1.6-4.61 2.84-6.55 2.84",
      "fill": "#f68d7f"
    }
  }), _c('path', {
    attrs: {
      "d": "m48.71 80.12a5.31 5.31 0 0 1 -2.58-.56.7.7 0 0 1 .71-1.2c.08 0 1.57.85 4.3-.06a.7.7 0 1 1 .44 1.32 9 9 0 0 1 -2.87.5",
      "fill": "#f89f85"
    }
  }), _c('path', {
    attrs: {
      "d": "m32.46 41.08a10.19 10.19 0 0 0 -6.17 1.35c-1.55.92-.06 3.28 1.48 2.36a7.8 7.8 0 0 1 4.82-.92 1.39 1.39 0 0 0 1.33-1.45 1.43 1.43 0 0 0 -1.45-1.33",
      "fill": "#724a40"
    }
  }), _c('path', {
    attrs: {
      "d": "m71.48 42.43a10.22 10.22 0 0 0 -6.18-1.35 1.43 1.43 0 0 0 -1.46 1.33 1.4 1.4 0 0 0 1.33 1.46 7.82 7.82 0 0 1 4.82.92c1.54.92 3-1.44 1.49-2.36",
      "fill": "#724a40"
    }
  }), _c('path', {
    attrs: {
      "d": "m9.32 63.88a1.77 1.77 0 1 1 -1.77-1.77 1.77 1.77 0 0 1 1.77 1.77",
      "fill": "#fff"
    }
  }), _c('path', {
    attrs: {
      "d": "m8 64.82a1.41 1.41 0 0 1 -1.4-1.4 1.38 1.38 0 0 1 1-1.31 1.77 1.77 0 1 0 1.77 1.77s0-.08 0-.13a1.38 1.38 0 0 1 -1.37 1.07",
      "fill": "#e3e3e3"
    }
  }), _c('path', {
    attrs: {
      "d": "m91.39 63.88a1.77 1.77 0 1 1 -1.77-1.77 1.77 1.77 0 0 1 1.77 1.77",
      "fill": "#fff"
    }
  }), _c('path', {
    attrs: {
      "d": "m90 64.82a1.4 1.4 0 0 1 -1.4-1.4 1.38 1.38 0 0 1 1-1.31 1.77 1.77 0 1 0 1.77 1.77s0-.08 0-.13a1.38 1.38 0 0 1 -1.37 1.07",
      "fill": "#e3e3e3"
    }
  }), _c('path', {
    attrs: {
      "d": "m38 55.4a7.33 7.33 0 1 1 -7.34-7.33 7.34 7.34 0 0 1 7.34 7.33",
      "fill": "#fff"
    }
  }), _c('path', {
    attrs: {
      "d": "m36.68 55.4a4.73 4.73 0 1 1 -4.73-5 4.86 4.86 0 0 1 4.73 5",
      "fill": "#8a6855"
    }
  }), _c('path', {
    attrs: {
      "d": "m30.71 62.73h-.26a4.46 4.46 0 0 1 -.74 0 7.14 7.14 0 0 1 -1.15-.15 7.21 7.21 0 0 1 -1.44-.49 7.45 7.45 0 0 1 -2.92-2.48 7.68 7.68 0 0 1 -1-2 8.41 8.41 0 0 1 -.35-2.28 8.59 8.59 0 0 1 .35-2.23 7.63 7.63 0 0 1 1-2 7.05 7.05 0 0 1 1.39-1.51 6.93 6.93 0 0 1 4.12-1.59 4.39 4.39 0 0 1 .74 0h.26-.26c-.17 0-.41 0-.72.13a6.87 6.87 0 0 0 -1.07.32 9.79 9.79 0 0 0 -1.28.63 8 8 0 0 0 -1.31 1 7.47 7.47 0 0 0 -1.14 1.43 7.18 7.18 0 0 0 0 7.51 7.47 7.47 0 0 0 1.15 1.43 7.8 7.8 0 0 0 1.31 1 9.62 9.62 0 0 0 1.28.63 6.89 6.89 0 0 0 1.07.31 7.26 7.26 0 0 0 .72.13h.26",
      "fill": "#e9967d"
    }
  }), _c('path', {
    attrs: {
      "d": "m59.79 55.4a7.33 7.33 0 1 0 7.33-7.33 7.33 7.33 0 0 0 -7.33 7.33",
      "fill": "#fff"
    }
  }), _c('path', {
    attrs: {
      "d": "m61.16 55.4a4.73 4.73 0 1 0 4.72-5 4.85 4.85 0 0 0 -4.72 5",
      "fill": "#8a6855"
    }
  }), _c('path', {
    attrs: {
      "d": "m67.13 62.73h.26a7.26 7.26 0 0 0 .72-.13 6.89 6.89 0 0 0 1.07-.31 9.69 9.69 0 0 0 1.28-.63 7.93 7.93 0 0 0 1.31-1 7.5 7.5 0 0 0 1.14-1.43 7.21 7.21 0 0 0 .78-5.74 7.81 7.81 0 0 0 -.78-1.78 7.46 7.46 0 0 0 -1.15-1.43 7.9 7.9 0 0 0 -1.31-1 9.8 9.8 0 0 0 -1.28-.63 6.87 6.87 0 0 0 -1.07-.32c-.3-.08-.55-.1-.72-.13h-.26.26a4.39 4.39 0 0 1 .74 0 7.22 7.22 0 0 1 5.52 3.12 7.63 7.63 0 0 1 1 2 8.54 8.54 0 0 1 .36 2.06 8.37 8.37 0 0 1 -.35 2.28 7.63 7.63 0 0 1 -1 2 7.47 7.47 0 0 1 -2.92 2.48 7 7 0 0 1 -2.6.64 4.46 4.46 0 0 1 -.74 0h-.26",
      "fill": "#e9967d"
    }
  }), _c('path', {
    attrs: {
      "d": "m90.27 53.36a4.62 4.62 0 0 1 3.26 1.07 29.72 29.72 0 0 1 .41-3.24 74.78 74.78 0 0 0 .06-8.38c-.32-7.58-1.23-15.51-5.38-22.05a44.2 44.2 0 0 0 -16.3-15.3 47.89 47.89 0 0 0 -19.26-5.36 72.94 72.94 0 0 0 -15.25 1s-40.22 5.82-33.25 53.12c0 0 .33-.77 3-.81-.06 0 1.37-4.72 1.43-5a21.88 21.88 0 0 1 11.5-15.41s12.51-3 16.24-7.82c0 0 5.46 13.84 18.92 19.81 0 0-10.4-8.22-12.76-17.78 0 0 5.3 15.86 47.38 26.14",
      "fill": "#b67753"
    }
  }), _c('path', {
    attrs: {
      "d": "m42.67 88.85h12.42v5.56h-12.42z",
      "fill": "#feb28c"
    }
  }), _c('path', {
    attrs: {
      "d": "m55.09 90.5v-1.65h-12.42v3.39a28.12 28.12 0 0 0 12.42-1.74",
      "fill": "#e69780"
    }
  }), _c('path', {
    attrs: {
      "d": "m24.81 147s-4.46-18.92 8.09-38.62c0 0-1.34-3.25-4.13-2.44 0 0-17 19.33-8.55 42.11 0 0 2.8 3.77 4.6-1.06",
      "fill": "#fab18c"
    }
  }), _c('path', {
    attrs: {
      "d": "m20.64 157.53a13.58 13.58 0 0 1 -2.39-6.08s-.43-3.2 1.1-4.71c0 0 2.29-3 5.38-1.1a5.56 5.56 0 0 1 1.57 2.22l.09.16a9 9 0 0 0 1.84 2.38c1.3 1.11.4 2.09.4 2.09a1.09 1.09 0 0 1 -1.57 0c-.54-.51-1.06-1-1.59-1.57-.95-.62-.95.22-.95.22a33.08 33.08 0 0 0 2.27 4.86 1.07 1.07 0 0 1 -.41 1.39s-.63.68-2.06-1.48a16.86 16.86 0 0 1 -1.79-4.12 18.78 18.78 0 0 0 1.72 4.48c1 1.26-.13 1.78-.13 1.78-1.45.36-2.42-2.49-2.42-2.49-.93-2.5-1.41-3.5-1.41-3.5l1.51 4.05s.76 1.33.08 1.72c0 0-.53.47-1.24-.27",
      "fill": "#fab18c"
    }
  }), _c('path', {
    attrs: {
      "d": "m72.49 147s4.46-18.92-8.09-38.62c0 0 1.34-3.25 4.14-2.44 0 0 17 19.33 8.55 42.11 0 0-2.81 3.77-4.6-1.05",
      "fill": "#fab18c"
    }
  }), _c('path', {
    attrs: {
      "d": "m76.65 157.52a13.63 13.63 0 0 0 2.35-6.08s.42-3.2-1.1-4.71c0 0-2.28-3-5.37-1.1a5.51 5.51 0 0 0 -1.53 2.22l-.09.15a8.92 8.92 0 0 1 -1.84 2.38c-1.29 1.11-.4 2.09-.4 2.09a1.09 1.09 0 0 0 1.57 0c.54-.51 1.06-1 1.59-1.57.94-.61.95.23.95.23a33.18 33.18 0 0 1 -2.28 4.87 1.07 1.07 0 0 0 .41 1.39s.63.68 2.06-1.48a16.73 16.73 0 0 0 1.79-4.12 18.69 18.69 0 0 1 -1.76 4.44c-1 1.26.13 1.77.13 1.77 1.45.36 2.42-2.48 2.42-2.48.97-2.52 1.45-3.52 1.45-3.52l-1.51 4.05s-.76 1.33-.07 1.72c0 0 .52.47 1.23-.27",
      "fill": "#fab18c"
    }
  }), _c('path', {
    attrs: {
      "d": "m42.53 203.25h-8.72l-1.98-34.59h12.68z",
      "fill": "#f4ab91"
    }
  }), _c('path', {
    attrs: {
      "d": "m42.53 203.25h-8.72l-1.98-34.59h12.68z",
      "fill": "#fab18c"
    }
  }), _c('g', {
    attrs: {
      "clip-path": "url(#d)",
      "opacity": ".5"
    }
  }, [_c('path', {
    attrs: {
      "d": "m31.83 168.66v2.53h9.27l-1.99 32.06h3.42l1.99-34.59z",
      "fill": "#f4ab91"
    }
  })]), _c('path', {
    attrs: {
      "d": "m38.53 200.71c-1.73 0-4.38.27-5.39 1.93v1.23s-1.67 4.79 3.49 5.29c0 0 6.48 1.24 6.26-5.29v-.22a4.54 4.54 0 0 0 -4.37-2.94",
      "fill": "#fab18c"
    }
  }), _c('path', {
    attrs: {
      "d": "m38.23 215.09s5.74 0 5.54-6.36l-.55-6.39c-.24-2.75-5.56-2.88-5.56-2.88-4.43.1-5.15 2.88-5.15 2.88l-3.14 6.83s-2 6.46 8.87 5.91m3.35-12.08c.09 1.52.05 3.51-1.17 4.65-1.4 1.31-4.24.76-5.8.1-1.78-.76-1.6-3.61-.68-5 0 0 .66-1.73 3.72-1.6 0 0 3.6 0 3.93 1.87",
      "fill": "#f7799b"
    }
  }), _c('path', {
    attrs: {
      "d": "m38.29 213.11c-6.2.32-8.35-1.56-9-3.32-.19 1.6.16 5.75 9 5.3 0 0 5.57 0 5.53-6.11-1.13 4.13-5.47 4.12-5.47 4.12",
      "fill": "#fff"
    }
  }), _c('g', {
    attrs: {
      "clip-path": "url(#e)"
    }
  }, [_c('path', {
    attrs: {
      "d": "m31.83 206.06a19.93 19.93 0 0 1 -.39 2l-.11.46a2 2 0 0 0 -.09.43 1.22 1.22 0 0 0 .19.77c0 .13.19.2.27.31l.4.25a8.57 8.57 0 0 0 1 .42c.36.12.72.25 1.08.34s.73.21 1.08.25l1 .19.94.09c.59.1 1.08 0 1.43.07h.56l-.53.16-.62.17a3.44 3.44 0 0 1 -.83.14l-1 .08-1.12-.06a11.22 11.22 0 0 1 -2.38-.53 10.37 10.37 0 0 1 -1.15-.52 5.08 5.08 0 0 1 -.57-.41 2.55 2.55 0 0 1 -.42-.58 1.88 1.88 0 0 1 -.16-1.32 2.22 2.22 0 0 1 .2-.52l.2-.43c.51-1.09.93-1.79.93-1.79",
      "fill": "#fff"
    }
  })]), _c('path', {
    attrs: {
      "d": "m55.41 203.25h8.71l1.99-34.59h-12.69z",
      "fill": "#f4ab91"
    }
  }), _c('path', {
    attrs: {
      "d": "m55.41 203.25h8.71l1.99-34.59h-12.69z",
      "fill": "#fab18c"
    }
  }), _c('g', {
    attrs: {
      "clip-path": "url(#f)",
      "opacity": ".5"
    }
  }, [_c('path', {
    attrs: {
      "d": "m66.11 168.66v2.53h-9.27l1.99 32.06h-3.42l-1.99-34.59z",
      "fill": "#f4ab91"
    }
  })]), _c('path', {
    attrs: {
      "d": "m64.85 202.51a5.94 5.94 0 0 0 -4.64-2c-2 .13-4.16.74-5.14 2.49v.9c-.22 6.53 6.26 5.29 6.26 5.29 5.16-.5 3.49-5.29 3.49-5.29z",
      "fill": "#fab18c"
    }
  }), _c('path', {
    attrs: {
      "d": "m68.63 209.18-3.15-6.83s-.72-2.78-5.15-2.87c0 0-5.32.13-5.56 2.88l-.55 6.39c-.2 6.39 5.54 6.36 5.54 6.36 10.9.55 8.87-5.91 8.87-5.91m-8.3-8.09c3.06-.13 3.72 1.6 3.72 1.6.92 1.41 1.1 4.26-.68 5-1.56.66-4.4 1.21-5.8-.1-1.22-1.15-1.26-3.13-1.17-4.65.33-1.87 3.93-1.87 3.93-1.87",
      "fill": "#f7799b"
    }
  }), _c('path', {
    attrs: {
      "d": "m59.7 213.11c6.2.32 8.35-1.56 9-3.32.19 1.6-.16 5.75-9 5.3 0 0-5.57 0-5.53-6.11 1.13 4.13 5.47 4.12 5.47 4.12",
      "fill": "#fff"
    }
  }), _c('g', {
    attrs: {
      "clip-path": "url(#g)"
    }
  }, [_c('path', {
    attrs: {
      "d": "m66.16 206.06s.1.81.39 2l.11.46a2.35 2.35 0 0 1 .09.43 1.24 1.24 0 0 1 -.2.77c0 .13-.19.2-.27.31l-.4.25a8.72 8.72 0 0 1 -1 .42c-.37.12-.73.25-1.09.34s-.72.21-1.08.25l-1 .19-.94.09c-.59.1-1.08 0-1.44.07h-.56l.53.16.62.17a3.42 3.42 0 0 0 .83.14l1 .08 1.12-.06a11.14 11.14 0 0 0 2.38-.53 10.08 10.08 0 0 0 1.15-.52 5.08 5.08 0 0 0 .57-.41 2.49 2.49 0 0 0 .42-.58 1.91 1.91 0 0 0 .16-1.32 2.56 2.56 0 0 0 -.2-.52l-.19-.43c-.51-1.09-.93-1.79-.93-1.79",
      "fill": "#fff"
    }
  })]), _c('path', {
    attrs: {
      "d": "m68.68 98.93a6.09 6.09 0 0 0 -4.11-4.37l-11-2.17h-9.33l-11 2.17a6.08 6.08 0 0 0 -4.11 4.38c-.72 21.19-1.35 33-2.59 50a60.53 60.53 0 0 0 22.35 3.37 60.53 60.53 0 0 0 22.38-3.31c-.51-8.9-1.54-28.34-2.59-50",
      "fill": "#feb28c"
    }
  }), _c('path', {
    attrs: {
      "d": "m55.87 92.85 8.66 1.71a6.09 6.09 0 0 1 4.11 4.38c.83 16.8 1.24 27 2.59 50a60.53 60.53 0 0 1 -22.35 3.37 60.52 60.52 0 0 1 -22.35-3.31c1-18.08 1.66-28.22 2.59-50a6.09 6.09 0 0 1 4.11-4.37l8.28-1.63s.12 5.32 7 5.18c0 0 6.56.84 7.34-5.26",
      "fill": "#9482bd"
    }
  }), _c('path', {
    attrs: {
      "d": "m33.07 94.61s-7.77.29-10.9 10.18l-2.28 5.92a12.57 12.57 0 0 0 11 6.13s4.68-14.21 2.23-22.23",
      "fill": "#926db0"
    }
  }), _c('path', {
    attrs: {
      "d": "m64.36 94.61s7.77.29 10.9 10.18l2.28 5.92a12.57 12.57 0 0 1 -11 6.13s-4.68-14.21-2.22-22.23",
      "fill": "#926db0"
    }
  }), _c('g', {
    attrs: {
      "fill": "#f7799b"
    }
  }, [_c('path', {
    attrs: {
      "d": "m28 172.71a2.32 2.32 0 1 1 -2.32-2.32 2.32 2.32 0 0 1 2.32 2.32"
    }
  }), _c('path', {
    attrs: {
      "d": "m32.14 173.92a2.32 2.32 0 1 1 -2.32-2.32 2.32 2.32 0 0 1 2.32 2.32"
    }
  }), _c('path', {
    attrs: {
      "d": "m36.33 174.67a2.32 2.32 0 1 1 -2.33-2.32 2.32 2.32 0 0 1 2.32 2.32"
    }
  }), _c('path', {
    attrs: {
      "d": "m40.49 175.2a2.32 2.32 0 1 1 -2.32-2.32 2.32 2.32 0 0 1 2.32 2.32"
    }
  }), _c('path', {
    attrs: {
      "d": "m44.68 175.61a2.32 2.32 0 1 1 -2.32-2.32 2.32 2.32 0 0 1 2.32 2.32"
    }
  }), _c('path', {
    attrs: {
      "d": "m49.15 175.61a2.32 2.32 0 1 1 -2.32-2.32 2.32 2.32 0 0 1 2.32 2.32"
    }
  }), _c('path', {
    attrs: {
      "d": "m53.52 175.91a2.32 2.32 0 1 1 -2.32-2.32 2.32 2.32 0 0 1 2.32 2.32"
    }
  }), _c('path', {
    attrs: {
      "d": "m57.75 175.61a2.32 2.32 0 1 1 -2.32-2.32 2.32 2.32 0 0 1 2.32 2.32"
    }
  }), _c('path', {
    attrs: {
      "d": "m62.09 175a2.32 2.32 0 1 1 -2.32-2.32 2.32 2.32 0 0 1 2.32 2.32"
    }
  }), _c('path', {
    attrs: {
      "d": "m66.14 174.67a2.32 2.32 0 1 1 -2.32-2.32 2.32 2.32 0 0 1 2.32 2.32"
    }
  }), _c('path', {
    attrs: {
      "d": "m70.28 173.6a2.32 2.32 0 1 1 -2.28-2.32 2.32 2.32 0 0 1 2.32 2.32"
    }
  }), _c('path', {
    attrs: {
      "d": "m74.23 172.71a2.32 2.32 0 1 1 -2.32-2.32 2.32 2.32 0 0 1 2.32 2.32"
    }
  })]), _c('path', {
    attrs: {
      "d": "m71.28 148.41 2.86 23.59c-28.09 6.7-50.52-.32-50.52-.32l2.67-23a173.68 173.68 0 0 0 45-.25",
      "fill": "#9482bd"
    }
  }), _c('path', {
    attrs: {
      "d": "m.13 110.62 11.87-8.62v-61.73l-7-8a463.49 463.49 0 0 0 -4.87 78.35",
      "fill": "#b67753"
    }
  }), _c('g', {
    attrs: {
      "clip-path": "url(#h)",
      "opacity": ".1"
    }
  }, [_c('path', {
    attrs: {
      "d": "m10.22 50.18s-.85 10.38-1.72 19a29 29 0 0 0 -1.32-7.76 70 70 0 0 0 -3.24 9.31s-1.08-12.68 1.4-21.73c0 0-.52 6.63 1.7 10.41a27.55 27.55 0 0 1 3.18-9.19",
      "fill": "#fff"
    }
  })]), _c('g', {
    attrs: {
      "clip-path": "url(#i)",
      "opacity": ".1"
    }
  }, [_c('path', {
    attrs: {
      "d": "m9.24 76.72s-.85 10.38-1.72 19a29 29 0 0 0 -1.31-7.72 70.14 70.14 0 0 0 -3.21 9.27s-1.12-12.67 1.36-21.77c0 0-.52 6.63 1.7 10.41a27.55 27.55 0 0 1 3.18-9.19",
      "fill": "#fff"
    }
  })]), _c('path', {
    attrs: {
      "d": "m39.24 112.26h19.28v20.29h-19.28z",
      "fill": "#926db0"
    }
  }), _c('g', {
    attrs: {
      "clip-path": "url(#j)",
      "opacity": ".1"
    }
  }, [_c('path', {
    attrs: {
      "d": "m72.78 13.24a45 45 0 0 0 -20.34-1.35c17.11 6.31 19.23 11.11 19.23 11.11-8.71-5.26-19.6-6-19.6-6 2.55 5.92 13.57 8.89 13.57 8.89-15.25-.28-18.64-7.44-18.64-7.44-3.1-1.72-3.62 4-3.62 4a7.38 7.38 0 0 0 -4.84-6.75l.21-11.34s23.91-5 34.06 8.89",
      "fill": "#fff"
    }
  })]), _c('g', {
    attrs: {
      "clip-path": "url(#k)",
      "opacity": ".1"
    }
  }, [_c('path', {
    attrs: {
      "d": "m20.49 23.58c3.19-4.27 9.38-7.84 9.38-7.84-7.73 2.26-15.94 9.44-15.94 9.44 3.49-7.37 11.55-12.8 11.55-12.8a24.5 24.5 0 0 0 -10.73 5.88c11.43-13.6 23.53-14.07 23.53-14.07l-2 18.18s-2.22-5.09-15.82 1.2",
      "fill": "#fff"
    }
  })]), _c('g', {
    attrs: {
      "clip-path": "url(#l)",
      "opacity": ".1"
    }
  }, [_c('path', {
    attrs: {
      "d": "m68.51 31.91s18.29 6.21 21.11 14.09a27.82 27.82 0 0 0 -5-9.3s5.78 1 7.22 5.81c0 0 .75-11.49-19.16-17.07 0 0 7.48 4.39 9.86 9.59 0 0-7.09-5-14.07-3.11",
      "fill": "#fff"
    }
  })]), _c('g', {
    attrs: {
      "clip-path": "url(#m)",
      "opacity": ".1"
    }
  }, [_c('path', {
    attrs: {
      "d": "m26.26 27.48s-16.91 9.33-18.26 17.59a27.84 27.84 0 0 1 3.25-10s-5.51 2-6.08 7c0 0-2.76-11.18 15.85-20.18 0 0-6.59 5.64-8 11.17 0 0 6.1-6.19 13.3-5.54",
      "fill": "#fff"
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-409e8c79","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/mentoring/components/avatar/components/stub/components/girl/MentoringGirlIcon.vue
// module id = 96d2bd95e93303e2c2aa
// module chunks = 89